import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { getMember } from './point.interface';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-point',
  templateUrl: './point.component.html',
  styleUrls: ['./point.component.scss']
})
export class PointComponent {
  contentRank = environment.contentRank
  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.GetExchangerate();
  }


  memberItems!: getMember
  tel: string = ""
  searchMember() {
    let model = {
      Tel: parseInt(this.tel)
    }
    this.http.post(`member/search`, model).subscribe({
      next: (res: any) => {
        this.memberItems = res.data
      }, error: () => {

      }, complete: () => {

      }
    })
  }
  ExchangerateItem: any = []
  GetExchangerate() {
    this.http.get(`point/exchangerate`).subscribe({
      next: (res: any) => {
        this.ExchangerateItem = res.data
      }, error: () => {

      }, complete: () => {

      }
    })
  }

  calculatePoints(amountSpent: number): number {
    const pointsPerBaht = this.ExchangerateItem.RatePoint / this.ExchangerateItem.RateAmount;
    return Math.floor(amountSpent * pointsPerBaht);
  }

  point: number = 0
  amount: number = 0
  Amount(e: any) {
    this.amount = parseInt(e.value)
    this.point = this.calculatePoints(e.value)

  }

  AddPoint() {
    let model = {
      Amount: this.amount,
      Point: this.point,
      Member_id: this.memberItems.Member_id
    }
    this.http.post(`point`, model).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
        this.memberItems = {} as getMember;
        this.tel = ""
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

      }
    })
  }

}

